import { Box, Button, CircularProgress, Grid, Switch, TextField } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid2 from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { Program } from "../model/program";
import { useEffect, useState } from "react";
import LockIcon from '@mui/icons-material/Lock';

import ClearAllIcon from '@mui/icons-material/ClearAll';
import LinearScaleIcon from '@mui/icons-material/LinearScale';

interface OverviewProps {
    program: Program | null
    updateDescription: (programId: string, description: string) => void
    updateNavigation: (programId: string, navigation: string) => void
}


export const Overview = ({program, updateDescription, updateNavigation}: OverviewProps) => {
    const [programDescription, setProgramDescription] = useState<string | null>(program?.description || '');
    const [navigation, setNavigation] = useState<string>(program?.navigation || "parallel");
    
    const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDescription = event.target.value;
        setProgramDescription(newDescription);
    };

    useEffect(() => {
        setProgramDescription(program?.description || '');
    }, [program]);

    // add debounce in ms
    useEffect(() => {
        const handler = setTimeout(() => {
            if (program && programDescription !== null && program.description != programDescription) {
                updateDescription(program.id, programDescription);
            }
            
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [programDescription]);

    return (
        <>
            <Grid item>
                <TextField
                    label="Program Description"
                    placeholder="Users of the program will see this description."
                    multiline
                    rows={4}
                    fullWidth
                    value={programDescription || ''}
                    onChange={handleDescriptionChange}
                    variant="outlined"
                    sx={{ margin: 2 }}
                />
                <Grid display={"flex"} flexDirection={"column"} alignItems={"start"} justifySelf={"start"} padding={"20px"}>
                    <Typography variant="caption">Content</Typography>
                    <Grid display={"flex"} flexDirection={"row"} alignItems={"center"}>
                        <LinearScaleIcon/>
                        <Switch
                            defaultChecked
                            checked={navigation == "parallel"}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                let navigation = event.target.checked ? "parallel" : "sequential"
                                setNavigation(navigation);

                                if (program) {
                                    updateNavigation(program?.id, navigation)
                                }
                            }}
                        />
                        <ClearAllIcon/>
                    </Grid>
                    <Typography variant="body2" textAlign={"start"} alignItems={"center"}>
                        In Parallel mode
                        <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle', mx: 0.5 }}>
                            <ClearAllIcon/> 
                        </Box>
                        users can choose themselves which chapters to start with (default). In Sequential mode 
                        <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle', mx: 0.5 }}>
                            <LinearScaleIcon/>
                        </Box>
                        the 1st chapter needs to be completed before the user can start the 2nd chapter. 
                    </Typography>

                </Grid>
            </Grid>
        </>
    )
}